import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider
} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import store from './store.js'
import './assets/styles/bootstrap.custom.css';
import './assets/styles/index.css';
import App from './App';
import MetaPixelTracker from './components/MetaPixelTracker.jsx';
import reportWebVitals from './reportWebVitals';
import PrivateRoute from './components/PrivateRoute.jsx';
import AdminRoute from './components/AdminRoute.jsx';
import HomeScreen from './screens/HomeScreen';
import ProductScreen from './screens/ProductScreen';
import CartScreen from './screens/CartScreen';
import PhoneLoginScreen from './screens/PhoneLoginScreen.jsx';
import RegisterScreen from './screens/RegisterScreen.jsx';
import ShippingScreen from './screens/ShippingScreen.jsx';
import PlaceOrderScreen from './screens/PlaceOrderScreen.jsx';
import OrderScreen from './screens/OrderScreen.jsx';
import ProfileScreen from './screens/ProfileScreen.jsx';
import OrderListScreen from './screens/admin/OrderListScreen.jsx';
import ProductListScreen from './screens/admin/ProductListScreen.jsx';
import ProductEditScreen from './screens/admin/ProductEditScreen.jsx';
import UserListScreen from './screens/admin/UserListScreen.jsx';
import UserEditScreen from './screens/admin/UserEditScreen.jsx';
import ContactScreen from './screens/ContactScreen.jsx';
import AboutScreen from './screens/AboutScreen.jsx';
import WhatsAppScreen from './screens/admin/WhatsAppScreen.jsx';
import DeliveryPartnerApp from './DeliveryPartnerApp.js';
import DeliveryPartnerRoute from './components/DeliveryPartnerRoute.jsx';
import DeliveryPartnerRegisterScreen from './screens/deliverypartner/DeliveryPartnerRegisterScreen.jsx';
import DeliveryPartnerLoginScreen from './screens/deliverypartner/DeliveryPartnerLoginScreen.jsx';
import DeliveryPartnerHomeScreen from './screens/deliverypartner/DeliveryPartnerHomeScreen.jsx';
import DeliveryPartnerDocumentsScreen from './screens/deliverypartner/DeliveryPartnerDocumentsScreen.jsx';

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
    <Route element={<MetaPixelTracker />}></Route>

    <Route path='/' element={<App/>}>
      <Route index={true} path='/' element={<HomeScreen/>}/>
      <Route path='/search/:keyword' element={<HomeScreen/>}/>
      <Route path='/page/:pageNumber' element={<HomeScreen/>}/>
      <Route path='/search/:keyword/page/:pageNumber' element={<HomeScreen/>}/>
      <Route path='/product/:id' element={<ProductScreen/>}/>
      <Route path='/cart' element={<CartScreen/>}/>
      <Route path='/login' element={<PhoneLoginScreen/>}/>
      <Route path='/register' element={<RegisterScreen/>}/>
      <Route path='/about' element={<AboutScreen/>}/>
      <Route path='/contact' element={<ContactScreen/>}/>

      <Route path='' element={<PrivateRoute/>}>
        <Route path='/shipping' element={<ShippingScreen/>}/>
        <Route path='/placeorder' element={<PlaceOrderScreen/>}/>
        <Route path='/order/:id' element={<OrderScreen/>}/>
        <Route path='/profile' element={<ProfileScreen/>}/>
      </Route>

      <Route path='' element={<AdminRoute/>}>
        <Route path='/admin/orderlist' element={<OrderListScreen/>}/>
        <Route path='/admin/productlist' element={<ProductListScreen/>}/>
        <Route path='/admin/productlist/page/:pageNumber' element={<ProductListScreen/>}/>
        <Route path='/admin/product/:id/edit' element={<ProductEditScreen/>}/>
        <Route path='/admin/userlist' element={<UserListScreen/>}/>
        <Route path='/admin/user/:id/edit' element={<UserEditScreen/>}/>
        <Route path='/admin/whatsapp' element={<WhatsAppScreen/>}/>
      </Route>
    </Route>

    <Route path='/deliverypartner' element={<DeliveryPartnerApp/>}>
      <Route path='register' element={<DeliveryPartnerRegisterScreen />} />
      <Route path='login' element={<DeliveryPartnerLoginScreen />} />
      <Route path='' element={<DeliveryPartnerRoute/>}>
        <Route index={true} element={<DeliveryPartnerHomeScreen/>}/>
        <Route path='documents' element={<DeliveryPartnerDocumentsScreen />} />
      </Route>
    </Route>
    </>
  )
)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <RouterProvider router={router}/>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);

window.addEventListener("error", (event) => {
  if (event.error?.code === "auth/internal-error") {
    event.preventDefault();
    window.location.reload();
  }
});

window.addEventListener("unhandledrejection", (event) => {
  if (event.reason?.code === "auth/internal-error") {
    event.preventDefault();
    window.location.reload();
  }
});

reportWebVitals();